import { Box } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import type { FontVariant } from './fontVariant';

export const PlainTextFix = ({
  fontVariant = 'font16',
  text,
}: {
  fontVariant?: FontVariant;
  text: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography variant={fontVariant}>{text}</Typography>
    </Box>
  );
};
